import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetch_lkp_LeedCertification, fetchComplexityAnswers, fetch_lkp_Complexity, postComplexityAnswers } from '../../actions/additional_actions';
import ComplexityFactorForm from './ComplexityFactorForm';


class ComplexityFactor extends React.Component {
  constructor (props) {
    super(props);
    
    this.onPostComplexityAnswers = this.onPostComplexityAnswers.bind(this);
    this.postComplexityAnswers = this.postComplexityAnswers.bind(this);
    this.getListComplexityModel = this.getListComplexityModel.bind(this);
  }

  componentDidMount() {
    this.props.fetch_lkp_LeedCertification();
    this.props.fetch_lkp_Complexity(this.props.projectId);
    this.props.fetchComplexityAnswers(this.props.projectId);
  }

  getListComplexityModel (complexityList) {
    const { projectId } = this.props;
    let listComplexityModel = [];

    complexityList && complexityList.forEach(element => {
        if (element.yesNoAnswer !== null) {
            listComplexityModel.push({projectId, complexityId: element.complexityId, yesNoAnswer: element.yesNoAnswer});
        } else if (element.yearBuiltAnswer !== "") {
            listComplexityModel.push({projectId, complexityId: element.complexityId, yearBuiltAnswer: element.yearBuiltAnswer});
        } else if (element.leedCertificationId != "") {
            listComplexityModel.push({projectId, complexityId: element.complexityId, leedCertificationId: element.leedCertificationId});
        }
    });

    listComplexityModel.id = projectId;
    return listComplexityModel;
}

  postComplexityAnswers(complexityAnswers){
    var answerList = this.getListComplexityModel(complexityAnswers);
    debugger;
    this.props.postComplexityAnswers(answerList);
  }

  onPostComplexityAnswers() {
    this.props.fetch_lkp_Complexity(this.props.projectId);
  }

  render () {
    return (        
     <div>
         <ComplexityFactorForm 
            complexityQuestions={this.props.projectComplexity}
            complexityAnswers={this.props.projectComplexitySelected}
            leedOptions={this.props.leedOptions}
            onSubmit={this.postComplexityAnswers}
            onModalClose={this.props.onModalClose}
         />
     </div>
    )
  }
}

ComplexityFactor.propTypes = {
    projectId: PropTypes.string.isRequired,
    fetch_lkp_LeedCertification: PropTypes.func.isRequired,
    fetch_lkp_Complexity: PropTypes.func.isRequired,
    fetchComplexityAnswers: PropTypes.func.isRequired,
    postComplexityAnswers: PropTypes.func.isRequired,
    projectComplexity: PropTypes.array.isRequired,
    leedOptions: PropTypes.array.isRequired,
    projectComplexitySelected: PropTypes.array.isRequired,
    onModalClose: PropTypes.func.isRequired
};

function mapStateToProps(state) {
    return {
        leedOptions: state.additionalProjectsStore.leedCertification,
        projectComplexity: state.additionalProjectsStore.complexity,
        projectComplexitySelected: state.additionalProjectsStore.complexityAnswersSelected
    };
}

export default connect(mapStateToProps, {fetch_lkp_LeedCertification, fetchComplexityAnswers, fetch_lkp_Complexity, postComplexityAnswers}) (ComplexityFactor);
